import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../../Global/Base/Rights/RightTypes";
import { ActionContext, ActionType, IActionContext, SelectionType } from "../../../../UI.Controls/Actions/IAction";
import { MenuType } from "../../../../UI.Controls/Actions/MenuType";
import { Control } from "../../Controls/Control";
import { IFrame } from "../IFrame";
import { XGAction } from "./XGAction";

export class StandardAction extends XGAction {
    //#region Fields

    public ownerIFrame: Control;

    public override action: (context?: IActionContext) => Promise<void>;
    private readonly _context: ActionContext;
    private readonly _actionType: ActionType;
    private _supportedSelectionModes: SelectionType = SelectionType.single;
    //#endregion Fields

    //#region Properties

    public override get context(): ActionContext {
        return this._context;
    }

    public override get actionType(): ActionType {
        return this._actionType;
    }

    public override get supportedSelectionModes(): SelectionType {
        return this._supportedSelectionModes;
    }

    public override set supportedSelectionModes(value: SelectionType) {
        this._supportedSelectionModes = value;
    }

    //#endregion Properties

    //#region Constructors
    constructor(actionType: ActionType, action: () => Promise<void>, lockey: string, context: ActionContext = ActionContext.objectAction, priority: number = 1, owner?: IFrame) {
        super({ element: document.createElement("div"), originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });

        this._context = context;
        this._actionType = actionType;
        this.locKey = lockey;
        if (actionType === ActionType.standardPreviousRecord ||
            actionType === ActionType.standardNextRecord)
            this.toMenu = MenuType.mtRecordNavigation;
        else
            this.toMenu = MenuType.mtStandardAction;
        this.enabled = false; //na zacatku se vsechny akce nastavi na neaktivni

        this.action = action;
        this.priority = priority;
        this.element.classList.add("StandardAction");
        this.owner = owner;
    }
    //#endregion Constructors

    //#region Methods
    protected override _internalExecute(context?: IActionContext): Promise<void> {
        return this.action(context);
    }
//#endregion Methods
}
